export default __webpack_public_path__ + "static/media/Dagger of Nebthu.fe31af8c.jpg";